import { EMPTY_LIST } from '../../../../constants/common'
import { EmailTableRow } from '../../../Email'
import { Container } from '../../Container'
import { getTableRowData, TABLE_ROW_VISIBLE_COLUMNS } from '../Emails.mocks'

function EmailsTableRow() {
  return (
    <>
      <Container label='Email table row, without actions, with owner, subject, text, service request, date'>
        <EmailTableRow
          Actions={null}
          columns={TABLE_ROW_VISIBLE_COLUMNS}
          item={getTableRowData({ files: [], folders: [], labels: [] })}
          selected={EMPTY_LIST}
        />
      </Container>
      <Container label='Email table row, without actions, with owner, subject, text, labels, files, service request, date'>
        <EmailTableRow
          Actions={null}
          columns={TABLE_ROW_VISIBLE_COLUMNS}
          item={getTableRowData()}
          selected={EMPTY_LIST}
        />
      </Container>
      <Container label='Email table row, with actions, owner, subject, text, service request, date'>
        <EmailTableRow
          actionColumnWidth={112}
          columns={TABLE_ROW_VISIBLE_COLUMNS}
          item={getTableRowData({ files: [], folders: [], labels: [] })}
          selected={EMPTY_LIST}
        />
      </Container>
      <Container label='Email table row, with actions, owner, subject, text, labels, files, service request, date'>
        <EmailTableRow
          actionColumnWidth={112}
          columns={TABLE_ROW_VISIBLE_COLUMNS}
          item={getTableRowData()}
          selected={EMPTY_LIST}
        />
      </Container>
    </>
  )
}

export default EmailsTableRow
